var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_149_178)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0008 0H2.00084C0.896012 0 0 0.896001 0 1.99916V14.0008C-2.02105e-07 15.104 0.896011 16 2.00084 16H14.0008C15.104 16 16 15.104 16 14.0008V1.99916C16 0.896001 15.104 0 14.0008 0ZM12.9667 5.70779C10.8278 7.85347 9.27327 9.6 7.09221 11.7861L6.43368 12.4446L5.72463 11.8434L3.09052 9.61515L2.31748 8.95663L3.62105 7.41053L4.39412 8.064L6.31242 9.68421C8.11452 7.84673 9.59663 6.22147 11.5368 4.27621L12.2526 3.55705L13.6825 4.98694L12.9667 5.70779Z",
    fill: "#3EA138"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0402 3.77759V3.77939L12.0384 3.77759H12.0402Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_149_178"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.bdcf6d910dc65a5f3b47d79281ac2ed7.svg";
export { ForwardRef as ReactComponent };